<div class="options-chain-container">


    <!-- BODY -->
    <div class="chain-content">
        <!-- HEADER -->
        <div class="chain-header sticky-header">
            <div class="side-group">
                <span>Open (USDT)</span>
                <span>Delta</span>
                <span>Bid Size</span>
                <span>Bid / IV</span>
                <span>Mark / IV</span>
                <span>Ask / IV</span>
                <span>Ask Size</span>
            </div>

            <div class="strike-column">Strike</div>

            <div class="side-group">
                <span>Bid Size</span>
                <span>Bid / IV</span>
                <span>Mark / IV</span>
                <span>Ask / IV</span>
                <span>Ask Size</span>
                <span>Delta</span>
                <span>Open (USDT)</span>
            </div>
        </div>

        <div class="chain-row" tabindex="0" *ngFor="let row of chainData" [class.itm-call]="row.call?.isITM"
            [class.itm-put]="row.put?.isITM" [class.atm]="row.isATM">

            <!-- CALL SIDE -->
            <div class="side-group" (click)="selectContract(row,'CALL')">
                <span>{{ (row.call?.sumOpenInterestUsd) || 0 }}</span>

                <span [class.text-green]="row.call?.delta > 0" [class.text-red]="row.call?.delta < 0">
                    {{ row.call?.delta || 0 }}
                </span>

                <span class="cell" [style.background]="getGreenHeat(row.call?.bidSizeIntensity)">
                    {{ row.call?.bidSize || 0 }}
                </span>

                <span class="iv-text text-green">
                    {{ row.call?.bidIV || 0 }}
                </span>

                <div class="price-iv-cell">
                    <div class="price">
                        {{ row.call.markPrice | number:'1.2-2' }}
                    </div>
                    <div class="iv">
                        {{ (row.call.markIV * 100) | number:'1.2-2' }}%
                    </div>
                </div>


                <span class="iv-text text-red">
                    {{ row.call?.askIV || 0 }}
                </span>

                <span class="cell" [style.background]="getRedHeat(row.call?.askSizeIntensity)">
                    {{ row.call?.askSize || 0 }}
                </span>
            </div>

            <!-- STRIKE -->
            <div class="strike-column">
                {{ row.strike | number }}
            </div>

            <!-- PUT SIDE -->
            <div class="side-group" (click)="selectContract(row,'PUT')">
                <span class="cell" [style.background]="getGreenHeat(row.put?.bidSizeIntensity)">
                    {{ row.put?.bidSize || 0 }}
                </span>

                <span class="iv-text text-green">
                    {{ row.put?.bidIV || 0 }}
                </span>

                <div class="price-iv-cell">
                    <div class="price">
                        {{ row.put.markPrice | number:'1.2-2' }}
                    </div>
                    <div class="iv">
                        {{ (row.put.markIV * 100) | number:'1.2-2' }}%
                    </div>
                </div>

                <span class="iv-text text-red">
                    {{ row.put?.askIV || 0 }}
                </span>

                <span class="cell" [style.background]="getRedHeat(row.put?.askSizeIntensity)">
                    {{ row.put?.askSize || 0 }}
                </span>

                <span [class.text-green]="row.put?.delta > 0" [class.text-red]="row.put?.delta < 0">
                    {{ row.put?.delta || 0 }}
                </span>

                <span>{{ row.put?.sumOpenInterestUsd || 0 }}</span>
            </div>

        </div>
    </div>

</div>